import React from 'react';
import { Badge, type BadgeProps } from '@chakra-ui/react';

interface IUnreadBadge {
  count: number;
  size?: 'sm' | 'md';
}

const UnreadBadge = (props: IUnreadBadge): React.ReactElement | null => {
  const { count, size = 'sm' } = props;

  const getSizeProps = (): BadgeProps => {
    if (size === 'md') {
      return {
        borderWidth: 2,
        width: 7,
        height: 7,
        fontSize: 'md',
        top: -1,
        right: -1,
      };
    }
    return {
      width: 5,
      height: 5,
      fontSize: 'sm',
      top: -1,
      right: -1,
    };
  };

  if (count > 0) {
    return (
      <Badge
        aria-label={`${count} unread messages`}
        variant="solid"
        colorScheme="pink"
        bgColor="pink.500"
        borderRadius="full"
        borderColor="white"
        position="absolute"
        justifyContent="center"
        pointerEvents="none"
        {...getSizeProps()}
      >
        {count}
      </Badge>
    );
  }
  return null;
};

export { UnreadBadge };
